import React from "react";
import styled from "styled-components";
import Image from "./Image";
import LinkGeneral from "./LinkGeneral";

const CardContainer = styled.div`
  background-color: #f2f2f2;
  box-shadow: 2px 2px 20px #ccc;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .title {
    color: #017180;
    display: inline-block;
    padding-right: 6rem;
    border-bottom: 5px solid #0ea296;
  }

  .text {
    padding-bottom: 9rem;
  }
  .button {
    background-color: #a2d249;
    color: #fff;
    font-weight: bold;
    text-align: center;
  }
`;

const CardHome = ({ title, description, src, href }) => (
  <CardContainer>
    <div>
      <LinkGeneral href={href}>
        <Image src={src}></Image>
      </LinkGeneral>

      <LinkGeneral href={href}>
        <h4 className="title mx-3 my-4">
          <b>{title}</b>
        </h4>
      </LinkGeneral>

      <div className="text px-3">{description}</div>
    </div>

    <LinkGeneral href={href}>
      <div className="button fs-responsive-m">ver más...</div>
    </LinkGeneral>
  </CardContainer>
);

export default CardHome;
